import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { getUsers } from "../../../helpers/urlConfig/apiFunctions";
import UserCreate from "./UserCreate";
import UserEdit from "./UserEdit";
import DeleteComponent from "../../../Components/Common/deleteComponent/DeleteComponent";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import { documentTitle } from "../../../helpers/documentTitle";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

const UserList = () => {
  const [modal_list, setmodal_list] = useState(false);
  const [modal_delete, setmodal_delete] = useState(false);
  const [edit_modal_list, set_edit_modal_list] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [deleteId, setDeleteUserId] = useState(null);

  const [users, setUsers] = useState([]);

  const tog_list = () => setmodal_list(!modal_list);
  const edit_tog_list = () => set_edit_modal_list(!edit_modal_list);
  const tog_delete = () => setmodal_delete(!modal_delete);

  documentTitle("Users");

  const fetchData = async () => {
    try {
      const sessionUserType = getSessionData("user_type");

      const body = {
        user_type: sessionUserType,
      };

      const response = await getUsers(body);

      if (response.statusCode === 200) {
        setUsers(response.data);
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEditClick = (user) => {
    setCurrentUser(user);
    set_edit_modal_list(true);
  };

  const onClickRemoveBtn = (id) => {
    setDeleteUserId(id);
    tog_delete();
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(users);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
    XLSX.writeFile(workbook, "Users.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Users List", 14, 10);
    doc.autoTable({
      head: [["SL.No", "User Name", "Phone", "User Type"]],
      body: users.map((user, index) => [
        index + 1,
        user.user_name,
        user.phone_number,
        user.user_type,
      ]),
    });
    doc.save("Users.pdf");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="User List"
            pageTitle="User"
            exportToExcel={exportToExcel}
            exportToPDF={exportToPDF}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div>
                          <Button
                            color="success"
                            className="add-btn me-1"
                            onClick={tog_list}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add
                          </Button>
                          {/* <Button
                            color="primary"
                            onClick={exportToExcel}
                            className="me-1"
                          >
                            Excel
                          </Button>
                          <Button color="secondary" onClick={exportToPDF}>
                            PDF
                          </Button> */}
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table className="table align-middle table-nowrap">
                        <thead className="table-light">
                          <tr>
                            <th>SL.No</th>
                            <th>User Name</th>
                            <th>Mobile Number</th>
                            <th>User Type</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users.map((users, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{users.user_name}</td>
                              <td>{users.phone_number}</td>
                              <td>{users.user_type}</td>
                              <td>
                                <div className="d-flex gap-2">
                                  <div className="edit">
                                    <button
                                      className="btn btn-sm btn-success"
                                      onClick={() => handleEditClick(users)}
                                    >
                                      Edit
                                    </button>
                                  </div>
                                  {users.user_id !=
                                    getSessionData("user_id") && (
                                    <div className="remove">
                                      <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() =>
                                          onClickRemoveBtn(users.user_id)
                                        }
                                      >
                                        Remove
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {users.length === 0 && (
                        <div className="text-center mt-4">
                          <p>No Users found.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <UserCreate
        modal_list={modal_list}
        setmodal_list={setmodal_list}
        tog_list={tog_list}
        fetchData={fetchData}
      />

      {edit_modal_list && (
        <UserEdit
          modal_list={edit_modal_list}
          setmodal_list={set_edit_modal_list}
          tog_list={edit_tog_list}
          fetchData={fetchData}
          currentUser={currentUser}
        />
      )}

      <DeleteComponent
        modal_delete={modal_delete}
        tog_delete={tog_delete}
        fetchData={fetchData}
        deleteId={deleteId}
        keyName="User"
      />

      {/* Delete Confirmation Modal */}
      {/* <Modal isOpen={modal_delete} toggle={tog_delete} centered>
        <ModalHeader toggle={tog_delete}>Confirm Delete</ModalHeader>
        <ModalBody>
          <p>Are you sure you want to delete this user?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={tog_delete}>
            Delete
          </Button>
          <Button color="secondary" onClick={tog_delete}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal> */}
    </React.Fragment>
  );
};

export default UserList;
